import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NodeService } from './node.service';
import { Idol } from '../app/app.models';

const name = 'idols_db';

@Injectable()
export class IdolsStorageService {
  idols: Idol[] = [];

  constructor(private storage: Storage, private nodeService: NodeService) {
    this.getStorageIdols();
  }
  getStorageIdols() {
    return this.storage
      .get(name)
      .then((idols: Idol[]) => {
        return (this.idols = idols != null ? idols : []);
      })
      .catch(err => console.log(err));
  }

  setIdols() {
    var index = 1;
    if (this.idols.length > 0) {
      index = this.idols.length + 1;
    }
    return this.nodeService.getConcretIdols(index).then(response => {
      if (response.length > 0) {
        for (let item of response) {
          this.idols.push(item);
        }
        return this.storage.set(name, this.idols).then(idols => {
          return this.idols.slice();
        });
      }
      return this.idols.slice();
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/idols.storage.service.ts